import React, { useContext } from 'react';
import { styled } from '@mui/material';

import { Box, Container, Copyright, Logo, Stack } from 'shell/components';
import { PageContext } from 'pages/SignUpPage/PageProvider';
import { useViewport } from 'contexts/viewport';
import { FinishedSignUpPage, SignUpPage } from 'components/organisms/SignUp';

const Tablet = () => {
    const { device } = useViewport();
    const {
        loading,
        currentStep,
        form,
        ToSModalOpen,
        country,
        errors,
        setToSModalOpen,
        handleSignUp,
        handleChange,
        handleResendCode,
        COUNTRY_OPTIONS,
        PAGES,
    } = useContext(PageContext);

    return (
        <Container device={device} sx={{ height: '100%', pb: 3 }}>
            <CenterBox>
                <Stack alignItems={'center'}>
                    <Logo device={'desktop'} />
                </Stack>
                {currentStep === PAGES.CREATE_ACCOUNT && (
                    <SignUpPage
                        loading={loading}
                        device={device}
                        errors={errors}
                        country={country}
                        form={form}
                        handleChange={handleChange}
                        handleSignUp={handleSignUp}
                        ToSModalOpen={ToSModalOpen}
                        setToSModalOpen={setToSModalOpen}
                        COUNTRY_OPTIONS={COUNTRY_OPTIONS}
                    />
                )}
                {currentStep === PAGES.VERIFY_EMAIL && (
                    <FinishedSignUpPage device={device} handleResendCode={handleResendCode} />
                )}
            </CenterBox>
            <Copyright />
        </Container>
    );
};

const CenterBox = styled(Box)(({ theme }) => {
    return {
        paddingTop: theme.spacing(18),
        width: 'fit-content',
        height: '100%',
    };
});

export default Tablet;
